import React, { useEffect, useState } from "react";
import "./paymentDrawer.scss";
import '../../molecules/PaymentBox/methodSwitch.scss';
import BtnCircular from "../../../ds/BtnCircular/BtnCircular";
import PaymentNusxa from "../../molecules/PaymentNusxa/PaymentNusxa";
import SelectAddress from "../../molecules/SelectAddress/SelectAddress";
import PaymentSummary from "../../molecules/PaymentSummary/PaymentSummary";
import PickupLocationBox from "../../molecules/PickupLocationBox/PickupLocationBox";
import ListItem from "../../../ds/ListItem/ListItem";
import OrderTableLabel from "../../../ds/OrderTableLabel/OrderTableLabel";
import ChooseAddressBox from "../../molecules/ChooseAddressBox/ChooseAddressBox";
import AddressDrawer from "../AddressDrawer/AddressDrawer";
import DeliveryDrawer from "../../molecules/DeliveryDrawer/DeliveryDrawer";
import { useCustomerAddresses } from "../../../hooks/address";
import { usePickupLocations } from "../../../hooks/pickupLocations";
import { Returntext } from "../../../pages/Landings/common/returnText";
import { useContent, useLanguages } from "../../../hooks/content";
import { ReactComponent as CloseIcon } from "../../../icons/x.svg";
import { ReactComponent as HomeIcon } from "../../../icons/home.svg";
import { ReactComponent as WorkIcon } from "../../../icons/work.svg";
import { ReactComponent as ArrowRightIcon } from "../../../icons/arrow-r.svg";
import { useUnpaidOrders } from "../../../hooks/orders";
import { useUserData } from "../../../hooks/users";
import useMobileVhFix from "../../../hooks/height";
import Lottie from "lottie-react";
import LoaderAnimation from "../../../assets/animations/Loaders/1 - Green/data.json";

// Same delivery method values used by PaymentDrawer / DeliveryDrawer.
const MODE = {
  DELIVERY: "delivery",
  PICKUP: "pickup",
};

const SettlePaymentDrawer = ({ cancelClick, setActiveOrder, activeOrder }) => {
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [paymentSuccess, setPaymentSucces] = useState(false);
  const [totalValue, setTotalValue] = useState(0);
  const { data: userData } = useUserData();

  const [cadActive, setCadActive] = useState(false);

  const { unpadidOrders } = useUnpaidOrders(userData.id);

  useEffect(() => {
    setSelectedOrders(unpadidOrders.filteredOrders);
    setTotalValue(unpadidOrders.total);

    if (unpadidOrders.filteredOrders.length > 0) {
      setActiveOrder(unpadidOrders.filteredOrders[0]);
    } else {
      setActiveOrder([]);
    }
  }, [unpadidOrders]);

  const { customerAddresses } = useCustomerAddresses();
  const { pickupLocations } = usePickupLocations();

  const [address, setAddress] = useState(
    customerAddresses !== undefined && customerAddresses.length !== 0
      ? customerAddresses.find((address) => address.isDefault === true)
      : ""
  );

  const [addressDrawer, setAddressDrawer] = useState(false);

  // Pickup / delivery mode state — same as PaymentDrawer.
  // If the first unpaid order already carries a pickup_location_id (saved by
  // an earlier flow) open in pickup mode with that selection pre-filled.
  const initialMode = activeOrder?.pickup_location_id
    ? MODE.PICKUP
    : MODE.DELIVERY;
  const [mode, setMode] = useState(initialMode);
  const [pickupLocationId, setPickupLocationId] = useState(
    activeOrder?.pickup_location_id || ""
  );

  const pickupAvailable = pickupLocations.length > 0;

  const nextClick = () => {
    setPaymentSucces(true);
  };

  const { lang } = useLanguages();

  // Pickup has its own copy ("<key>_pickup" in content management); falls
  // back to the delivery text until those identifiers are filled in.
  const modeText = (key) =>
    (mode === MODE.PICKUP &&
      Returntext(contentManagementData, `${key}_pickup`, lang)) ||
    Returntext(contentManagementData, key, lang);
  const { contentManagementData } = useContent();

  useMobileVhFix();

  const [loader, setLoader] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoader(false);
    }, 3500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className={paymentSuccess ? "" : "pod-drawer"}>
      {!paymentSuccess && (
        <>
          <div className="shadow" onClick={cancelClick}></div>
          <div className={`drawer-wrap ${loader && "load"}`}>
            <div className="header">
              <div className="left"></div>

              <div className="middle">
                {Returntext(contentManagementData, "PT", lang)}
              </div>

              <BtnCircular
                size={"sm"}
                mainColor={"white"}
                svg={<CloseIcon />}
                disabled={false}
                mode={"active"}
                onClick={cancelClick}
              />
            </div>

            {loader && (
              <div className="pd-loader">
                <Lottie animationData={LoaderAnimation} className="animation" />
              </div>
            )}

            {selectedOrders?.length > 0 && (
              <div className="body-c">
                <div className="d-wrap">
                  <div className="txts">
                    <div className="main">
                      {modeText("PDT")}
                    </div>
                    <div className="sub">
                      {modeText("PDB")}
                    </div>
                  </div>

                  {/* Selector: address vs office pickup */}
                  <div className="method-switch">
                    <button
                      type="button"
                      className={`method ${
                        mode === MODE.DELIVERY ? "active" : ""
                      }`}
                      onClick={() => setMode(MODE.DELIVERY)}
                    >
                      <div className="main">{Returntext(contentManagementData, 'payment_select_delivery', lang)}</div>
                    </button>
                    <button
                      type="button"
                      className={`method ${
                        mode === MODE.PICKUP ? "active" : ""
                      } ${!pickupAvailable ? "disabled" : ""}`}
                      onClick={() =>
                        pickupAvailable && setMode(MODE.PICKUP)
                      }
                      disabled={!pickupAvailable}
                    >
                      <div className="main">{Returntext(contentManagementData, 'payment_select_office_pickup', lang)}</div>
                    </button>
                  </div>

                  {mode === MODE.DELIVERY && (
                    <>
                      {address !== "" ? (
                        <ListItem
                          hasBorder={true}
                          hasPadding={true}
                          hasIcon={true}
                          headline={address.title}
                          description={address.address}
                          style={{ cursor: "pointer" }}
                          onClick={() => setCadActive(!cadActive)}
                          icon={
                            address.tag === "home" ? (
                              <HomeIcon />
                            ) : (
                              <WorkIcon />
                            )
                          }
                          buttons={
                            <>
                              {address.isDefault && (
                                <OrderTableLabel
                                  txt={Returntext(
                                    contentManagementData,
                                    "default",
                                    lang
                                  )}
                                />
                              )}
                              <ArrowRightIcon
                                style={{ marginLeft: "16px" }}
                              />
                            </>
                          }
                        />
                      ) : (
                        <SelectAddress setAddressDrawer={setAddressDrawer} />
                      )}

                      {cadActive && (
                        <ChooseAddressBox
                          address={address}
                          setAddress={setAddress}
                          setCadActive={setCadActive}
                          setAddressDrawer={setAddressDrawer}
                        />
                      )}
                    </>
                  )}

                  {mode === MODE.PICKUP && (
                    <PickupLocationBox
                      selectedId={pickupLocationId}
                      setSelectedId={setPickupLocationId}
                    />
                  )}
                </div>

                <PaymentNusxa
                  setSelectedOrders={setSelectedOrders}
                  selectedOrders={selectedOrders}
                  activeOrder={activeOrder}
                  main={modeText("PST")}
                  sub={modeText("PSB")}
                  totalValue={totalValue}
                  setTotalValue={setTotalValue}
                  all={true}
                />

                <PaymentSummary
                  nextClick={nextClick}
                  selectedOrders={selectedOrders}
                  totalValue={totalValue}
                  setActiveOrder={setActiveOrder}
                  activeOrder={activeOrder}
                  address={address}
                  cancelClick={cancelClick}
                  deliveryMode={mode}
                  pickupLocationId={pickupLocationId}
                />
              </div>
            )}
          </div>
        </>
      )}
      {addressDrawer && (
        <AddressDrawer
          cancelClick={() => setAddressDrawer(false)}
          setUserAddress={setAddress}
          style={{ zIndex: "999" }}
        />
      )}
      {paymentSuccess && (
        <DeliveryDrawer cancelClick={cancelClick} activeOrder={activeOrder} />
      )}
    </div>
  );
};

export default SettlePaymentDrawer;
